var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Station",
    transform: "translate(23 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    transform: "translate(-23 21)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cycle",
    transform: "translate(-14.698 29.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M6.7,2.5H19.4V1.564A1.566,1.566,0,0,0,17.831,0H1.564A1.566,1.566,0,0,0,0,1.564V19.4H2.5V18.61a3.41,3.41,0,0,0,2.19.785,3.439,3.439,0,0,0,.854-6.771l.305-1.893,3.258,4.249a1.543,1.543,0,0,0,.505,2.36l-.17.8H8.759v-.626H8.134v.626a.626.626,0,0,0,.626.626h1.877V19.4h.626V18.77a.626.626,0,0,0-.626-.626h-.552l.135-.636c.035,0,.069.011.1.011a1.567,1.567,0,0,0,1.533-1.251h.673a3.45,3.45,0,1,0,1.9-3.395L11.892,9.621l.249-1.174h.685V7.821H10.949v.626H11.5l-.2.938H6.069l.454-2.815h.985V5.944h-2.5v.626h.884l-.961,5.956c-.079-.005-.156-.012-.236-.012A3.411,3.411,0,0,0,2.5,13.3V6.7ZM10.35,16.89l.254-1.2-.612-.13-.24,1.132a.936.936,0,1,1,.6.2ZM14.281,13.7l1.155,1.478a.938.938,0,0,0-.362.468H13.158A2.811,2.811,0,0,1,14.281,13.7Zm1.986,2.259a.313.313,0,1,1-.313-.313A.313.313,0,0,1,16.267,15.954Zm-.313-2.815a2.815,2.815,0,1,1-2.8,3.128h1.916a.937.937,0,1,0,1.047-1.234l-1.294-1.656A2.794,2.794,0,0,1,15.954,13.139ZM13.9,13.2a3.437,3.437,0,0,0-1.368,2.439h-.673a1.566,1.566,0,0,0-1-1.151l.864-4.071Zm-3.658,1.2a1.547,1.547,0,0,0-.647.182l-3.5-4.57H11.17ZM2.5,5.814,5.814,2.5ZM3.937,2.5,2.5,3.937V2.5Zm.755,10.636c.046,0,.091,0,.136.007l-.3,1.887a.944.944,0,1,0,.617.1l.305-1.891a2.814,2.814,0,0,1-.754,5.525A2.79,2.79,0,0,1,2.5,17.718V14.191A2.79,2.79,0,0,1,4.692,13.139Zm.313,2.815a.313.313,0,1,1-.313-.313A.313.313,0,0,1,5.005,15.954Z",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/Station.3a4e55893a3cb8800620e109a0345e50.svg";
export { ForwardRef as ReactComponent };